import React from "react";
import SectionCard from "../../ui/SectionCard";
import { vaginalBleedingColourOptions } from "../../../config/symptomsConfig";

const COLOR_MAP: Record<string, string> = {
  bright_red: "#B2312C",
  dark_red: "#5A211E",
  brown: "#C8766B",
  yellowish: "#F5B9A6",
  clear: "#FFFFFF",
};

interface ColourSectionCardProps {
  value: string | null;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export default function ColourSectionCard({
  value,
  onChange,
  disabled = false,
}: ColourSectionCardProps) {
  return (
    <SectionCard
      title="Colour"
      description="Colour of vaginal bleeding after birth could change over time. Select the option that's closest to what you've observed."
    >
      <div className="flex items-start justify-between gap-2">
        {vaginalBleedingColourOptions.map((opt) => {
          const active = value === opt.value;
          const bgColor = COLOR_MAP[opt.value] || "#CCC";

          return (
            <button
              key={opt.value}
              type="button"
              disabled={disabled}
              onClick={() => onChange(opt.value)}
              className="flex flex-col items-center gap-2 disabled:opacity-50 focus:outline-none"
            >
              <div
                className={[
                  "w-14 h-14 rounded-full transition-all",
                  active ? "ring-4 ring-[#1e5e5b]/30" : "",
                  opt.value === "clear" ? "border-2 border-black/10" : "",
                ].join(" ")}
                style={{ backgroundColor: bgColor }}
              />
              <span className="text-xs text-black text-center leading-tight max-w-[56px]">
                {opt.label}
              </span>
            </button>
          );
        })}
      </div>
    </SectionCard>
  );
}
